/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import Controller from '@ember/controller';
import { isArray } from '@ember/array';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import moment from 'moment';
import { filterBy, mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class AbsenteesController extends Controller {
  @service
  attendanceCodes;

  @computed('model.{date,period}')
  get title() {
    let formattedDate = moment(this.model.date.date, 'YYYY-MM-DD').format(
      'dddd Do MMMM, YYYY',
    );
    return `Absentee list for ${formattedDate} (${this.model.period.longName})`;
  }

  @computed('model.records.@each.code')
  get absentees() {
    let absentCodes = mapBy(
      filterBy(this.get('attendanceCodes.allCodes'), 'inClass', false),
      'code',
    );
    let records = this.model.records;

    if (isArray(records)) {
      return records.filter((record) => {
        let code = record.get('code');
        return absentCodes.includes(code);
      });
    } else {
      return [];
    }
  }

  @alias('absentees.length')
  numAbsentees;

  sortProp = 'person.fullName';
  sortDir = 'asc';
}
